"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationCounts = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Typography = require("../Typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Shows pagination status: "x - y of z"
 * - If total is a number, that number is used.
 * - If total is a string, that string is used.
 * - If total is undefined, the last known value (or "many") is used.
*/
var PaginationCounts = function PaginationCounts(_ref) {
  var currentPage = _ref.currentPage,
      pageSize = _ref.pageSize,
      total = _ref.total;
  var currentPageInt = Math.floor(currentPage !== null && currentPage !== void 0 ? currentPage : 1);
  var pageSizeInt = Math.floor(pageSize !== null && pageSize !== void 0 ? pageSize : 0); // Remember the last correct value, or 1

  var totalRef = _react["default"].useRef('many');

  _react["default"].useEffect(function () {
    if (total !== undefined) {
      totalRef.current = total;
    }
  }, [total]);

  var totalFinal = total === undefined ? totalRef.current : total;
  var start = (currentPageInt - 1) * pageSizeInt + 1;
  var end = typeof totalFinal === 'number' ? Math.min(currentPageInt * pageSizeInt, totalFinal) : currentPageInt * pageSizeInt;
  return /*#__PURE__*/_react["default"].createElement(_Typography.BloxText, {
    className: "font-md-normal",
    $c: "var(--blox-slate3)"
  }, /*#__PURE__*/_react["default"].createElement(B, null, start), " - ", /*#__PURE__*/_react["default"].createElement(B, null, end), " of ", /*#__PURE__*/_react["default"].createElement(B, null, totalFinal));
};

exports.PaginationCounts = PaginationCounts;

var B = _styledComponents["default"].span.withConfig({
  displayName: "PaginationCounts__B",
  componentId: "sc-1vkkaqm-0"
})(["font-weight:700;"]);